import { render, staticRenderFns } from "./PontoMedicaoField.vue?vue&type=template&id=aa345834&scoped=true&"
import script from "./PontoMedicaoField.vue?vue&type=script&lang=js&"
export * from "./PontoMedicaoField.vue?vue&type=script&lang=js&"
import style0 from "./PontoMedicaoField.vue?vue&type=style&index=0&id=aa345834&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa345834",
  null
  
)

export default component.exports